import React, { useState, useEffect, useRef } from 'react';
import { getFirestore, collection, setDoc, doc, Timestamp, getDocs, deleteDoc, orderBy, query } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { app } from '../../firebase';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import swal from 'sweetalert';
import Spinner from 'react-bootstrap/Spinner';


function DarasaComp() {
  const db = getFirestore(app);
  const auth = getAuth();
  const [modalShow, setModalShow] = useState(false);
  const [instructors, setInstructors] = useState([]);
  const [classes, setClasses] = useState([]);

  // Refs for form fields
  const intakeDateRef = useRef();
  const classDescRef = useRef();
  const startDateRef = useRef();
  const startTimeRef = useRef();
  const endTimeRef = useRef();
  const selectInstructorRef = useRef();

  // Fetch instructors from Employee collection
  useEffect(() => {
    const fetchInstructors = async () => {
      const querySnapshot = await getDocs(collection(db, 'Employees'));
      const instructorsList = [];
      querySnapshot.forEach(doc => {
        instructorsList.push({ id: doc.id, ...doc.data() });
      });
      setInstructors(instructorsList);
    };

    fetchInstructors();
  }, []);

  // Fetch classes from Firestore
  useEffect(() => {
    const fetchClasses = async () => {
      const classesQuery = query(collection(db, 'allclasses'), orderBy('timeCreated', 'desc'));
      const querySnapshot = await getDocs(classesQuery);
      const classList = [];
      querySnapshot.forEach(doc => {
        classList.push({ id: doc.id, ...doc.data() });
      });
      setClasses(classList);
    };

    fetchClasses();
  }, []);

  const handleAddClass = async () => {
    const intakeDate = intakeDateRef.current.value;
    const classDesc = classDescRef.current.value;
    const startDate = startDateRef.current.value;
    const startTime = startTimeRef.current.value;
    const endTime = endTimeRef.current.value;
    const selectInstructor = selectInstructorRef.current.value;
    const myUserId = auth.currentUser.uid; // assuming you want the logged-in user as the creator
    const timeStamp = Timestamp.now();

    document.getElementById("submitBtn").style.display = "none";
    document.getElementById("spinnerBtn").style.display = "inline-block";
    // Step 1: Create room with Daily.co API
    try {
      const response = await fetch('https://api.daily.co/v1/rooms', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer 9ca6078bdb4b21b14f89f74bf52454758a58e2488b6ce5a04e640014f9fc5c7c', // Replace with your actual API key
        },
        body: JSON.stringify({
          properties: {
            // Example properties
          },
        }),
      });

      if (response.ok) {
        const data = await response.json();
        const roomUrl = data.name;  // Room URL retrieved from Daily.co API
        console.log(`Room URL: ${roomUrl}`);

        // Step 2: Add class details to Firestore
        const classDocRef = doc(db, 'allclasses', roomUrl); // Use roomUrl or a unique identifier as the doc ID

        await setDoc(classDocRef, {
          intakeDate: intakeDate,
          classDesc: classDesc,
          startDate: startDate,
          isActive: "Active",
          createdBy: myUserId,
          timeCreated: timeStamp,
          startTime: startTime,
          endTime: endTime,
          roomID: roomUrl,
          instructor: selectInstructor,
        });

        console.log("Document successfully written!");
        swal("Success", "Class created successfully!", "success");
        window.location.reload()
        //setModalShow(false); // Close modal after submission
      } else {
        console.error("Error creating room: ", response.statusText);
        swal("Error", "There was an error creating the room.", "error");
      }
    } catch (error) {
      console.error("Error during fetch: ", error);
      swal("Error", "Error during the room creation process.", "error");
    }
  };

  const handleDeleteClass = async (classId) => {
    const confirm = await swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this class!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });
  
    if (confirm) {
      try {
        await deleteDoc(doc(db, 'allclasses', classId));
        setClasses(prev => prev.filter(item => item.id !== classId));
        swal("Deleted!", "Class has been deleted.", "success");
        window.location.reload();
      } catch (error) {
        console.error("Error deleting class:", error);
        swal("Error", "Failed to delete class.", "error");
      }
    }
  };
   
  

  return (
    <div className="container mt-4 teamsComponent">
      <div className="teamsTopBar">
        <h3>Classes</h3>
        <Button className="mb-3" onClick={() => setModalShow(true)}>Create a class</Button>
      </div>

      {/* Modal for creating class */}
      <Modal show={modalShow} onHide={() => setModalShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Create Class</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Intake Date</Form.Label>
            <Form.Control type="date" ref={intakeDateRef} required />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Pathway</Form.Label>
            <Form.Select ref={classDescRef} required>
                <option value="Product Design">Product Design</option>
                <option value="Software Development">Software Development</option>
                <option value="Machine Learning">Machine Learning</option>
                <option value="Blockchain">Blockchain</option>
                <option value="Data Science">Data Science</option>
                <option value="Robotics">Robotics</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Start Date</Form.Label>
            <Form.Control type="date" ref={startDateRef} required />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Class Start Time</Form.Label>
            <Form.Control type="time" ref={startTimeRef} required />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Class End Time</Form.Label>
            <Form.Control type="time" ref={endTimeRef} required />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Select Instructor</Form.Label>
            <Form.Select ref={selectInstructorRef} required>
              <option value="">Select Instructor</option>
              {instructors.map(instructor => (
                <option key={instructor.id} value={instructor.id}>{instructor.employeeName}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalShow(false)}>Close</Button>
          <Button variant="primary" id="submitBtn" onClick={handleAddClass}>Submit</Button>
          <Button variant="primary" disabled id="spinnerBtn" style={{ display: 'none' }}>
            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
            <span> Submitting...</span>
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Displaying class cards */}
      <div className="row">
        {classes.map(classItem => {
          const isActive = String(classItem.isActive || '').toLowerCase().includes('active');
          return (
            <div className="col-xl-4 col-lg-4 mb-4" key={classItem.id}>
              <div className="classCard">
                <div className="classCardHeader">
                  <span className={`classBadge ${isActive ? 'classBadgeActive' : 'classBadgeInactive'}`}>
                    {classItem.isActive || 'Status'}
                  </span>
                  <p className="classTitle">{classItem.classDesc || 'Class'}</p>
                  <p className="classInstructor">
                    Instructor: <span>{
                      instructors.find(i => i.id === classItem.instructor)?.employeeName || "Unknown"
                    }</span>
                  </p>
                </div>

                <div className="classMeta">
                  <div className="classMetaItem">
                    <span>Start Time</span>
                    <strong>{classItem.startTime || '—'}</strong>
                  </div>
                  <div className="classMetaItem">
                    <span>End Time</span>
                    <strong>{classItem.endTime || '—'}</strong>
                  </div>
                  <div className="classMetaItem">
                    <span>Intake Date</span>
                    <strong>{classItem.intakeDate || '—'}</strong>
                  </div>
                  <div className="classMetaItem">
                    <span>Start Date</span>
                    <strong>{classItem.startDate || '—'}</strong>
                  </div>
                </div>

                <div className="classActions">
                  <a href={`view-classes?${classItem.roomID}`} className="classActionBtn classActionPrimary">
                    View Students
                  </a>
                  <Button
                    variant="danger"
                    size="sm"
                    className="classActionBtn classActionDanger"
                    onClick={() => handleDeleteClass(classItem.id)}
                  >
                    Delete Class
                  </Button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default DarasaComp;
